module.exports = "/images/groen-kennisnet.svg?a56e94968264807466a17b71e8b2cdea";